import { useEffect, useRef, useState } from 'react';

export function useSingleTabGuard(key: string | number | null | undefined): boolean {
  const [blocked, setBlocked] = useState(false);
  const blockedRef = useRef(false);

  useEffect(() => {
    if (!key || typeof BroadcastChannel === 'undefined') return;

    const channel = new BroadcastChannel(`agent-portal:${key}`);

    const handleMessage = (event: MessageEvent) => {
      if (blockedRef.current) return;
      if (event.data === 'ping') {
        channel.postMessage('pong');
      } else if (event.data === 'pong') {
        blockedRef.current = true;
        setBlocked(true);
      }
    };

    channel.addEventListener('message', handleMessage);
    channel.postMessage('ping');

    return () => {
      channel.removeEventListener('message', handleMessage);
      channel.close();
      blockedRef.current = false;
    };
  }, [key]);

  return blocked;
}

export default useSingleTabGuard;
